export default __webpack_public_path__ + "static/davide-cerato-1deccf31d2f852ad575dbcaa2f2be723.jpg";